/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DownloadFilesZip$Params {
      body: {
[key: string]: any;
}
}

export function downloadFilesZip(
  http: HttpClient,
  rootUrl: string,
  params: DownloadFilesZip$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Blob>> {

  const rb = new RequestBuilder(rootUrl, downloadFilesZip.PATH, 'post');

  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({
      responseType: 'blob' as 'json', 
      accept: '*/*',
      context
    })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}


downloadFilesZip.PATH = '/public/download_files_zip';
